import JSZip from 'jszip';
/**
 * This method will zip a file collection and return the zip as an ArrayBuffer
 * @param fileCollecrtion
 * @returns
 */
export async function fileCollectionToZip(fileCollection) {
    const jsZip = new JSZip();
    for (const file of fileCollection) {
        jsZip.file(file.relativePath, await file.arrayBuffer());
    }
    return jsZip.generateAsync({ type: 'uint8array' });
}
//# sourceMappingURL=fileCollectionToZip.js.map